export const capitalizeFirstLetter = (input: string): string => {
  if (!input || !input.length) {
    return '';
  }

  const result = input.charAt(0).toUpperCase() + input.slice(1);

  return result;
};

export const replaceIllegalCharacters = (filter: any): string => {
  if (filter !== '') {
    let result = JSON.stringify(filter.toString());
    result = result.replace(/'/g, `''`);
    result = result.replace(/^"|"$/g, `'`);
    return result;
  } else return '';
};

export const joinNotEmpty = (input: string[], separator?: string): string =>
  input.filter(Boolean).join(separator || ' ');
